<template>
  <div class="content">
    <el-row class="meal-left">
      <el-col :span="5">
        <div style="margin-top: .16rem">
          <el-avatar :size="50" :src="$route.query.sex=='男'?'static/img/huanzhenan.png':'static/img/huanzhenv.png'"></el-avatar>
        </div>
      </el-col>
      <el-col :span="19">
        <div class="meal-title">{{$route.query.name}}</div>
      </el-col>
    </el-row>
    <div class="hospital-name">北京航天总医院健康管理中心</div>
    <div class="hospital-describe">{{$route.query.describe}}</div>
    <div class="item-margin">
      <div class="item-title">
        <div class="item-title-icon"></div>
        <div class="item-title-margin">注意事项</div>
      </div>
      <div class="need-attention">
        肺部CT平扫:孕妇禁做，建议40岁以上人群选择此项检查。
      </div>
      <div class="need-attention">
        经颅多普勒脑血管超声:脑血管超声检查，6个月内做过眼部手术、激光治疗或眼底出血患者，不能选择此项目。
      </div>
    </div>
    <div class="border-icon"></div>
    <div>
      <el-tabs v-model="activeName" :stretch="true">
        <el-tab-pane label="套餐项目" name="first">
          <div class="meal-item" v-for="(item,index) in 6">
            <div class="meal-item-name">1.一般检查</div>
            <div class="meal-item-describe">诊断高血压、超重、肥胖、消瘦、及中心型肥胖,并且为相关科室的诊断提供重要的依据。</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="体检须知" name="second">
          <div class="meal-notice">
            团检客户请务必按照单位预约的体检日期、时间批次准点到达，如因个人原因不能参检者请在本单位体检周期内尽快补检。 个人体检客户请在约定的体检时间进行体检。 请您务必携带身份证到前台登记处办理体检手续。 检前 1、体检前一天晚8时后避免进食和剧烈运动，保证充足睡眠的时间。 2、体检当日禁食、禁水，患有高血压、糖尿病等慢性疾病，晨起可照常服药。 3、体检时穿宽松简便的衣物，不宜佩戴各种饰物，女士不宜穿连衣裙、连裤袜、不宜化妆，以免体检时造成不便。 4、女士体检避开月经期，妇科检查前24--48小时避免性生活。 5、如您习惯晨起大便，可用干净容器留取花生壳大小的大便带来。 检中 1、采血应空腹在上午10:00之前完成，以免影响检验结果的准确性。 2、如您有晕血、晕针史，请采血前告知采血护士，便于做好防范措施。 3、如您有糖尿病，请告知工作人员，采血、B超可优先安排，便于及时进食，避免发生低血糖等不良后果。 3、半年内计划怀孕者不宜照X光片及其它放射性检查，女性已怀孕者禁忌放射性检查。 4、下腹B超检查前需大量饮水，待膀胱充盈时方可进行检查。 5、尿标本应在下腹B超及妇科检查前留取。以免尿液稀释或被污染影响检验结果。 6、完成餐前检查（采血、上腹B超、口腔、耳鼻喉）后，到餐饮区领取营养早餐，并为糖尿病客户提供无糖早餐。 7、请按指引单逐项完成体检项目，不要漏检，以免影响结果汇总。。 检后 1、请完成所有检查项目后将体检指引单和检查结果单交至前台，以确保您能及时拿到体检报告。 2、检后服务：如在体检后发现重大阳性结果，主检医师会第一时间通知到您，并提供绿色就医通道。为了您的健康，我们的医生将会对您的情况进行追踪，请您予以配合。 3、结果查询：您可以通过健康管理中心官方微信平台查询体检结果。 4、报告领取：团检客户的体检报告由单位负责人统一领取，个检客户根据领取凭条上的日期和时间到档案室领取。个人体检客户可提供快递体检报告服务。 5、报告解读：体检报告分为三部分:体检综述、医生建议、检查结果。主检医生为您的体检异常结果提供了就诊建议和指导，请认真阅读。 6、体检报告属于个人隐私，我们为每一份体检报告都做了密封装订，请自行拆阅。 温馨提示 1、个人体检客户请您务必提供准确的联系电话，便于检后追踪服务和健康维护。 2、在检查区男女宾入口处设有存包柜，可以把随身携带物品放入柜中暂存。 3、健康管理中心为公共场所，体检时请保管好随时物品。前台设有失物招领处。
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="pay-btm">
      <el-row>
        <el-col :span="19">
          <div class="pay-left">个人支付：<span style="color: red">￥5021</span></div>
        </el-col>
        <el-col :span="5">
          <div class="pay-right">下一步</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
    export default {
      data(){
        return{
          activeName: 'first',
        }
      },
      created() {
        //修改标题
        document.title = this.$route.query.name
      }
    }
</script>

<style scoped>
  .meal-left{
    height: 1.5rem;
    text-align: center;
  }
  .meal-title{
    font-size: .34rem;
    font-weight: 700;
    text-align: left;
    line-height: 1.5rem;
  }
  .hospital-name{
    font-size: .28rem;
    font-weight: 600;
    margin-left: .2rem;
    line-height: .4rem;
    height: .6rem;
    border-bottom: 1px #eee solid;
  }
  .hospital-describe{
    font-size: .28rem;
    color: #999;
    margin-left: .2rem;
    height: .75rem;
    line-height: .75rem;
    border-bottom: 1px #eee solid;
  }
  .item-margin{
    margin: .2rem 0;
  }
  .item-title{
    position: relative;
    width: 100%;
    font-size: .34rem;
    font-weight: 700;
  }
  .item-title-icon{
    width: .16rem;
    height: 100%;
    background-color: #409eff;
    position: absolute;
    left: .2rem;
    top: 0;
  }
  .item-title-margin{
    padding-left: .5rem;
  }
  .need-attention{
    font-size: .28rem;
    color: #999;
    padding: .1rem .5rem 0 .5rem;
  }
  .border-icon{
    width: 100%;
    height: .2rem;
    background-color: #eee;
  }
  .meal-notice{
    font-size: .28rem;
    color: #999;
    margin: .1rem .3rem;
  }
  .meal-item{
    font-size: .28rem;
    padding: .2rem .4rem;
    border-bottom: 1px #eee solid;
  }
  .meal-item-name{
    font-size: .3rem;
    padding-bottom: .08rem;
  }
  .meal-item-describe{
    color: #999;
  }
  .pay-btm{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
  }
  .pay-left{
    height: .8rem;
    line-height: .8rem;
    font-size: .28rem;
    padding-left: .4rem;
    background-color: #fff;
  }
  .pay-right{
    height: .8rem;
    line-height:.8rem;
    background-color: #409EFF;
    font-size: .28rem;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/medicalPlanDetails.vue